export class HttpBodyRespModel {
	public status: number;
	public errorCode: number;
	public message: string;
	public data: any;
	public totalRecord: number;

	public convert(dto: any): HttpBodyRespModel {
		if (dto.status) {
			this.status = dto.status;
		}
		if (dto.errorCode) {
			this.errorCode = dto.errorCode;
		}
		if (dto.message) {
			this.message = dto.message;
		}
		if (dto.data) {
			this.data = dto.data;
		}
		if (dto.totalRecord >= 0) {
			this.totalRecord = dto.totalRecord;
		}

		return this;
	}
}
